// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-form-wrapper[data-v-4f5de289] {\n    max-width: 424px !important;\n}\n.login-logo[data-v-4f5de289] {\n    max-width: 424px !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
